import React from 'react';
import PropTypes from 'prop-types';
import {withStateHandlers} from 'recompose';
import cx from 'classnames';
import ArrowDown from 'modules/common/Svg/ArrowDown';

const Accordion = ({
  active,
  activeClass,
  activeStyle,
  className,
  handleClick,
  header,
  headerClassName,
  children,
}) => (
  <div className={className}>
    <div
      className={cx(headerClassName, {[activeClass]: active})}
      style={active ? activeStyle : {}}
      onClick={handleClick}>
      {header}
      <div className="pr2-ns pr1">
        <ArrowDown
          className={cx({
            'rotate-180': !active,
          })}
          color="black-80"
          width="13px"
          height="13px"
        />
      </div>
    </div>
    {active && children}
  </div>
);

Accordion.propTypes = {
  active: PropTypes.bool.isRequired,
  activeClass: PropTypes.string,
  activeStyle: PropTypes.object,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  header: PropTypes.node.isRequired,
  headerClassName: PropTypes.string,
};

const enhance = withStateHandlers(({active}) => ({active}), {
  handleClick: ({active}) => () => ({active: !active}),
});

export default enhance(Accordion);
